export default __webpack_public_path__ + "static/media/magon-2-kitchen-min.54f240a5.jpg";